import React from "react";
import { RightOutlined, DownOutlined } from "@ant-design/icons";
import { FormItem } from "./Items";
import dineroDisabledMask from "./dineroDisabledMask";
import { calcularTotalesOC } from "../Utils/OrdenDeCompra.utils";

/**
 * Renglón-encabezado de una familia en la tabla de insumos de una Orden de Compra.
 * Lo comparten Agregar y Editar OC a través de la `agrupacion` de
 * TabbedDynamicTable, para que el banner no se desincronice entre pantallas.
 *
 * Se lee a sí mismo del formulario con un `FormItem noStyle shouldUpdate` en vez
 * de recibir el arreglo por prop: así el subtotal se refresca cuando cambia una
 * cantidad o un precio de la familia, sin depender de que la tabla completa se
 * vuelva a renderizar. (Es el mismo patrón de la tarjeta de Totales.)
 *
 * El subtotal sale de `calcularTotalesOC` aplicado SÓLO a las filas de esta
 * familia: es la misma función que calcula el pie de la orden, así que la suma de
 * los grupos da exactamente el Subtotal y no aparece un tercer criterio de
 * redondeo. Se deja el `ignorarIncompletos` por omisión (true): una fila recién
 * agregada, sin insumo elegido todavía, no debe ensuciar el subtotal del grupo.
 *
 * @param {Object} grupo      { id, nombre } que devolvió `obtenerGrupo`
 * @param {Array}  arrayKeys  índices reales de las filas de esta familia
 * @param {String} listName   nombre del Form.List (por omisión "insumos")
 */
const EncabezadoFamiliaOC = ({
  grupo,
  arrayKeys,
  colapsado,
  alternar,
  totalColumnas,
  listName = "insumos",
}) => {
  const partidas = arrayKeys ? arrayKeys.length : 0;

  return (
    <FormItem
      noStyle
      shouldUpdate={(previo, actual) => previo[listName] !== actual[listName]}
    >
      {({ getFieldValue }) => {
        const insumos = getFieldValue(listName) || [];
        const filas = (arrayKeys || []).map((k) => insumos[k]).filter(Boolean);
        const { subtotal } = calcularTotalesOC(filas);

        return (
          <tr
            onClick={alternar}
            style={{ backgroundColor: "#e6f7ff", cursor: "pointer" }}
            title={
              colapsado
                ? "Mostrar los insumos de esta familia"
                : "Ocultar los insumos de esta familia"
            }
          >
            <td
              className="td-border"
              colSpan={totalColumnas}
              style={{
                textAlign: "left",
                padding: "8px 16px",
                borderBottom: "1px solid #91d5ff",
              }}
            >
              <span style={{ color: "#0050b3", marginRight: 8 }}>
                {colapsado ? <RightOutlined /> : <DownOutlined />}
              </span>
              <span
                style={{
                  fontWeight: 800,
                  fontSize: 11,
                  color: "#0050b3",
                  textTransform: "uppercase",
                  letterSpacing: 1,
                }}
              >
                {grupo.nombre || "Sin familia"}
              </span>
              <span style={{ fontSize: 11, color: "#0050b3", opacity: 0.75, marginLeft: 12 }}>
                {partidas} {partidas === 1 ? "partida" : "partidas"}
              </span>
              <span style={{ fontSize: 12, color: "#0050b3", fontWeight: 700, marginLeft: 12 }}>
                {dineroDisabledMask(subtotal)}
              </span>
            </td>
          </tr>
        );
      }}
    </FormItem>
  );
};

export default EncabezadoFamiliaOC;
